import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { SigninComponent } from './signin/signin.component';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { FormsModule } from '@angular/forms';
import { AuthService } from './auth.service';
import { SharedModule } from '../shared/shared.module';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { OtpComponent } from './otp/otp.component';
import { LoginModule } from '../login/login.module';
import { NewLoginComponent } from './new-login/new-login.component';
import { LoginUiModule } from './new-login/login-ui.module';

@NgModule({
  imports: [
    CommonModule,
    AuthRoutingModule,
    FormsModule,
    SharedModule,
    MDBBootstrapModulesPro.forRoot(),
    LoginModule,
    LoginUiModule,
  ],
  declarations: [
    SigninComponent,
    ResetPasswordComponent,
    OtpComponent,
    NewLoginComponent,
  ],
  exports: [LoginUiModule],
  providers: [AuthService]
})
export class AuthModule { }
